<!-- H5压缩包上传 -->
<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="span-div-red"><span class="span-upload">※ H5压缩包的目录及子目录中有且只能有一个入口文件index.html，且文件名中不能包含中文字符</span></div>
    <div class="span-div"><span class="span-upload">登录前首页位置1</span></div>
    <el-upload class="import-excel"
               ref="upload1"
               accept=".zip"
               :headers="myHeader"
               :action="uploadUrl"
               :data="myData1"
               :show-file-list="true"
               :multiple="false"
               :auto-upload="false"
               :on-success="handleSuccess1"
               :before-upload="beforeExcelUpload"
               :on-error="handleError"
               :file-list="fileList1"
               :on-change="changeFile1">
      <span class="span-upload-import">页面高度:</span>
      <el-input controls-position="right"
                label="页面高度"
                placeholder="页面高度"
                v-model="myData1.height"
                class="import-excel-input-num"
                type="number">
      </el-input>
      <span class="span-upload-import">网页压缩包:</span>
      <el-input :disabled="true"
                class="import-excel-input">
      </el-input>
      <el-button style="margin-left: 5px;"
                 slot="trigger"
                 type="primary"
                 icon="el-icon-plus"
                 class="upload-button">选取文件
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="success"
                 icon="el-icon-upload2"
                 @click="submitUpload1"
                 class="upload-button">上传文件
      </el-button>
      <el-button v-if="viewList[0] && viewList[0].paramValue && viewList[0].paramValue !== ''"
                 style="margin-left: 5px;"
                 type="info"
                 icon="el-icon-view"
                 @click="submitCheck(0)"
                 class="upload-button">查看
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="warning"
                 icon="el-icon-delete"
                 @click="submitDelete(1)"
                 class="upload-button">删除
      </el-button>
    </el-upload>

    <div class="span-div"><span class="span-upload">登录前首页位置2</span></div>
    <el-upload class="import-excel"
               ref="upload2"
               accept=".zip"
               :headers="myHeader"
               :action="uploadUrl"
               :data="myData2"
               :show-file-list="true"
               :multiple="false"
               :auto-upload="false"
               :on-success="handleSuccess2"
               :before-upload="beforeExcelUpload"
               :on-error="handleError"
               :file-list="fileList2"
               :on-change="changeFile2">
      <span class="span-upload-import">页面高度:</span>
      <el-input controls-position="right"
                label="页面高度"
                placeholder="页面高度"
                v-model="myData2.height"
                class="import-excel-input-num"
                type="number">
      </el-input>
      <span class="span-upload-import">网页压缩包:</span>
      <el-input :disabled="true"
                class="import-excel-input">
      </el-input>
      <el-button style="margin-left: 5px;"
                 slot="trigger"
                 type="primary"
                 icon="el-icon-plus">选取文件
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="success"
                 icon="el-icon-upload2"
                 @click="submitUpload2">上传文件
      </el-button>
      <el-button v-if="viewList[1] && viewList[1].paramValue && viewList[1].paramValue !== ''"
                 style="margin-left: 5px;"
                 type="info"
                 icon="el-icon-view"
                 @click="submitCheck(1)"
                 class="upload-button">查看
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="warning"
                 icon="el-icon-delete"
                 @click="submitDelete(2)"
                 class="upload-button">删除
      </el-button>
    </el-upload>

    <div class="span-div"><span class="span-upload">登录前首页位置3</span></div>
    <el-upload class="import-excel"
               ref="upload3"
               accept=".zip"
               :headers="myHeader"
               :action="uploadUrl"
               :data="myData3"
               :show-file-list="true"
               :multiple="false"
               :auto-upload="false"
               :on-success="handleSuccess3"
               :before-upload="beforeExcelUpload"
               :on-error="handleError"
               :file-list="fileList3"
               :on-change="changeFile3">
      <span class="span-upload-import">页面高度:</span>
      <el-input controls-position="right"
                label="页面高度"
                placeholder="页面高度"
                v-model="myData3.height"
                class="import-excel-input-num"
                type="number">
      </el-input>
      <span class="span-upload-import">网页压缩包:</span>
      <el-input :disabled="true"
                class="import-excel-input">
      </el-input>
      <el-button style="margin-left: 5px;"
                 slot="trigger"
                 type="primary"
                 icon="el-icon-plus">选取文件
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="success"
                 icon="el-icon-upload2"
                 @click="submitUpload3">上传文件
      </el-button>
      <el-button v-if="viewList[2] && viewList[2].paramValue && viewList[2].paramValue !== ''"
                 style="margin-left: 5px;"
                 type="info"
                 icon="el-icon-view"
                 @click="submitCheck(2)"
                 class="upload-button">查看
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="warning"
                 icon="el-icon-delete"
                 @click="submitDelete(3)"
                 class="upload-button">删除
      </el-button>
    </el-upload>

    <div class="span-div"><span class="span-upload">登录前首页位置4</span></div>
    <el-upload class="import-excel"
               ref="upload4"
               accept=".zip"
               :headers="myHeader"
               :action="uploadUrl"
               :data="myData4"
               :show-file-list="true"
               :multiple="false"
               :auto-upload="false"
               :on-success="handleSuccess4"
               :before-upload="beforeExcelUpload"
               :on-error="handleError"
               :file-list="fileList4"
               :on-change="changeFile4">
      <span class="span-upload-import">页面高度:</span>
      <el-input controls-position="right"
                label="页面高度"
                placeholder="页面高度"
                v-model="myData4.height"
                class="import-excel-input-num"
                type="number">
      </el-input>
      <span class="span-upload-import">网页压缩包:</span>
      <el-input :disabled="true"
                class="import-excel-input">
      </el-input>
      <el-button style="margin-left: 5px;"
                 slot="trigger"
                 type="primary"
                 icon="el-icon-plus">选取文件
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="success"
                 icon="el-icon-upload2"
                 @click="submitUpload4">上传文件
      </el-button>
      <el-button v-if="viewList[3] && viewList[3].paramValue && viewList[3].paramValue !== ''"
                 style="margin-left: 5px;"
                 type="info"
                 icon="el-icon-view"
                 @click="submitCheck(3)"
                 class="upload-button">查看
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="warning"
                 icon="el-icon-delete"
                 @click="submitDelete(4)"
                 class="upload-button">删除
      </el-button>
    </el-upload>

    <div class="span-div"><span class="span-upload">学院视界</span></div>
    <el-upload class="import-excel"
               ref="upload5"
               accept=".zip"
               :headers="myHeader"
               :action="uploadUrl"
               :data="myData5"
               :show-file-list="true"
               :multiple="false"
               :auto-upload="false"
               :on-success="handleSuccess5"
               :before-upload="beforeExcelUpload"
               :on-error="handleError"
               :file-list="fileList5"
               :on-change="changeFile5">
      <span class="span-upload-import">页面高度:</span>
      <el-input controls-position="right"
                label="页面高度"
                placeholder="页面高度"
                v-model="myData5.height"
                class="import-excel-input-num"
                type="number">
      </el-input>
      <span class="span-upload-import">网页压缩包:</span>
      <el-input :disabled="true"
                class="import-excel-input">
      </el-input>
      <el-button style="margin-left: 5px;"
                 slot="trigger"
                 type="primary"
                 icon="el-icon-plus">选取文件
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="success"
                 icon="el-icon-upload2"
                 @click="submitUpload5">上传文件
      </el-button>
      <el-button v-if="viewList[4] && viewList[4].paramValue && viewList[4].paramValue !== ''"
                 style="margin-left: 5px;"
                 type="info"
                 icon="el-icon-view"
                 @click="submitCheck(4)"
                 class="upload-button">查看
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="warning"
                 icon="el-icon-delete"
                 @click="submitDelete(5)"
                 class="upload-button">删除
      </el-button>
    </el-upload>

    <div class="span-div"><span class="span-upload">登录后学院视界</span></div>
    <el-upload class="import-excel"
               ref="upload8"
               accept=".zip"
               :headers="myHeader"
               :action="uploadUrl"
               :data="myData8"
               :show-file-list="true"
               :multiple="false"
               :auto-upload="false"
               :on-success="handleSuccess8"
               :before-upload="beforeExcelUpload"
               :on-error="handleError"
               :file-list="fileList8"
               :on-change="changeFile8">
      <span class="span-upload-import">页面高度:</span>
      <el-input controls-position="right"
                label="页面高度"
                placeholder="页面高度"
                v-model="myData8.height"
                class="import-excel-input-num"
                type="number">
      </el-input>
      <span class="span-upload-import">网页压缩包:</span>
      <el-input :disabled="true"
                class="import-excel-input">
      </el-input>
      <el-button style="margin-left: 5px;"
                 slot="trigger"
                 type="primary"
                 icon="el-icon-plus">选取文件
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="success"
                 icon="el-icon-upload2"
                 @click="submitUpload8">上传文件
      </el-button>
      <el-button v-if="viewList[7] && viewList[7].paramValue && viewList[7].paramValue !== ''"
                 style="margin-left: 5px;"
                 type="info"
                 icon="el-icon-view"
                 @click="submitCheck(7)"
                 class="upload-button">查看
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="warning"
                 icon="el-icon-delete"
                 @click="submitDelete(8)"
                 class="upload-button">删除
      </el-button>
    </el-upload>

    <div class="span-div"><span class="span-upload">加入BEST</span></div>
    <el-upload class="import-excel"
               ref="upload6"
               accept=".zip"
               :headers="myHeader"
               :action="uploadUrl"
               :data="myData6"
               :show-file-list="true"
               :multiple="false"
               :auto-upload="false"
               :on-success="handleSuccess6"
               :before-upload="beforeExcelUpload"
               :on-error="handleError"
               :file-list="fileList6"
               :on-change="changeFile6">
      <span class="span-upload-import">页面高度:</span>
      <el-input controls-position="right"
                label="页面高度"
                placeholder="页面高度"
                v-model="myData6.height"
                class="import-excel-input-num"
                type="number">
      </el-input>
      <span class="span-upload-import">网页压缩包:</span>
      <el-input :disabled="true"
                class="import-excel-input">
      </el-input>
      <el-button style="margin-left: 5px;"
                 slot="trigger"
                 type="primary"
                 icon="el-icon-plus">选取文件
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="success"
                 icon="el-icon-upload2"
                 @click="submitUpload6">上传文件
      </el-button>
      <el-button v-if="viewList[5] && viewList[5].paramValue && viewList[5].paramValue !== ''"
                 style="margin-left: 5px;"
                 type="info"
                 icon="el-icon-view"
                 @click="submitCheck(5)"
                 class="upload-button">查看
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="warning"
                 icon="el-icon-delete"
                 @click="submitDelete(6)"
                 class="upload-button">删除
      </el-button>
    </el-upload>

    <div class="span-div"><span class="span-upload">加入BMW经销商</span></div>
    <el-upload class="import-excel"
               ref="upload7"
               accept=".zip"
               :headers="myHeader"
               :action="uploadUrl"
               :data="myData7"
               :show-file-list="true"
               :multiple="false"
               :auto-upload="false"
               :on-success="handleSuccess7"
               :before-upload="beforeExcelUpload"
               :on-error="handleError"
               :file-list="fileList7"
               :on-change="changeFile7">
      <span class="span-upload-import">页面高度:</span>
      <el-input controls-position="right"
                label="页面高度"
                placeholder="页面高度"
                v-model="myData7.height"
                class="import-excel-input-num"
                type="number">
      </el-input>
      <span class="span-upload-import">网页压缩包:</span>
      <el-input :disabled="true"
                class="import-excel-input">
      </el-input>
      <el-button style="margin-left: 5px;"
                 slot="trigger"
                 type="primary"
                 icon="el-icon-plus">选取文件
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="success"
                 icon="el-icon-upload2"
                 @click="submitUpload7">上传文件
      </el-button>
      <el-button v-if="viewList[6] && viewList[6].paramValue && viewList[6].paramValue !== ''"
                 style="margin-left: 5px;"
                 type="info"
                 icon="el-icon-view"
                 @click="submitCheck(6)"
                 class="upload-button">查看
      </el-button>
      <el-button style="margin-left: 5px;"
                 type="warning"
                 icon="el-icon-delete"
                 @click="submitDelete(7)"
                 class="upload-button">删除
      </el-button>
    </el-upload>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      viewList: [], // 查看已上传页面url TODO
      myHeader: { token: '' }, // token
      myData1: { id: 1, height: 600 }, // 登录前首页位置1
      myData2: { id: 2, height: 600 }, // 登录前首页位置2
      myData3: { id: 3, height: 600 }, // 登录前首页位置3
      myData4: { id: 4, height: 600 }, // 登录前首页位置4
      myData5: { id: 5, height: 600 }, // 学苑视界
      myData6: { id: 6, height: 600 }, // 加入BEST
      myData7: { id: 7, height: 600 }, // 加入BMW经销商
      myData8: { id: 8, height: 600 }, // 登录后学苑视界
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: [],
      fileList7: [],
      fileList8: [],
      fileName1: '',
      fileName2: '',
      fileName3: '',
      fileName4: '',
      fileName5: '',
      fileName6: '',
      fileName7: '',
      fileName8: '',
      uploadUrl: '',
      url: '/sys/config/uploadFiles',
      hasError: false,
      fileList: []
    }
  },
  activated() {
    this.getUrl()
  },
  created() {
    this.uploadUrl = `${window.SITE_CONFIG['apiURL']}` + this.url
    this.myHeader.token = this.getStorage(this.GLOBAL.TOKEN)
    this.fileList1 = []
    this.fileList2 = []
    this.fileList3 = []
    this.fileList4 = []
    this.fileList5 = []
    this.fileList6 = []
    this.fileList7 = []
    this.fileList8 = []
  },
  methods: {
    submitUpload() {
      this.$refs.upload.submit();
    },
    // 获取查看url
    getUrl() {
      this.$request.get('/sys/config/protalH5List'
      ).then((res, total, code, data) => {
        this.viewList = res
      }).catch((err) => {
        console.log(err)
      })
    },
    indexMethod(index) {
      return index + 1
    },
    submitUpload1() {
      this.$refs.upload1.submit()
    },
    submitUpload2() {
      this.$refs.upload2.submit()
    },
    submitUpload3() {
      this.$refs.upload3.submit()
    },
    submitUpload4() {
      this.$refs.upload4.submit()
    },
    submitUpload5() {
      this.$refs.upload5.submit()
    },
    submitUpload6() {
      this.$refs.upload6.submit()
    },
    submitUpload7() {
      this.$refs.upload7.submit()
    },
    submitUpload8() {
      this.$refs.upload8.submit()
    },
    // 查看
    submitCheck(id) {
      window.open(this.viewList[id].paramValue, "_blank")
    },
    // 删除
    submitDelete(id) {
      this.$request.post('/sys/config/updateById',
        {
          id: id
        }
      ).then((res, total, code, data) => {
        this.$message({
          message: '操作成功',
          type: 'success',
          duration: 1500
        })
        this.getUrl()
      }).catch((err) => {
        console.log(err)
      })
    },
    changeFile1(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file.status === 'ready') {
        this.fileName1 = file.name
      }
    },
    changeFile2(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file.status === 'ready') {
        this.fileName2 = file.name
      }
    },
    changeFile3(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file.status === 'ready') {
        this.fileName3 = file.name
      }
    },
    changeFile4(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file.status === 'ready') {
        this.fileName4 = file.name
      }
    },
    changeFile5(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file.status === 'ready') {
        this.fileName5 = file.name
      }
    },
    changeFile6(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file.status === 'ready') {
        this.fileName6 = file.name
      }
    },
    changeFile7(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file.status === 'ready') {
        this.fileName7 = file.name
      }
    },
    changeFile8(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file.status === 'ready') {
        this.fileName8 = file.name
      }
    },
    // response接口返回值的全部 response.result为需要回显的文件存放位置
    handleSuccess1(response, file, fileList) {
      if (Number(fileList[0].response.code) < 0) {
        this.$alert(fileList[0].response.msg)
        this.fileList1 = []
        return 0
      }
      this.fileName1 = response.result
      this.$message({
        message: '操作成功',
        type: 'success',
        duration: 1500
      })
      this.getUrl()
    },
    handleSuccess2(response, file, fileList) {
      if (Number(fileList[0].response.code) < 0) {
        this.$alert(fileList[0].response.msg)
        this.fileList2 = []
        return 0
      }
      this.fileName2 = response.result
      this.$message({
        message: '操作成功',
        type: 'success',
        duration: 1500
      })
      this.getUrl()
    },
    handleSuccess3(response, file, fileList) {
      if (Number(fileList[0].response.code) < 0) {
        this.$alert(fileList[0].response.msg)
        this.fileList3 = []
        return 0
      }
      this.fileName3 = response.result
      this.$message({
        message: '操作成功',
        type: 'success',
        duration: 1500
      })
      this.getUrl()
    },
    handleSuccess4(response, file, fileList) {
      if (Number(fileList[0].response.code) < 0) {
        this.$alert(fileList[0].response.msg)
        this.fileList4 = []
        return 0
      }
      this.fileName4 = response.result
      this.$message({
        message: '操作成功',
        type: 'success',
        duration: 1500
      })
      this.getUrl()
    },
    handleSuccess5(response, file, fileList) {
      if (Number(fileList[0].response.code) < 0) {
        this.$alert(fileList[0].response.msg)
        this.fileList5 = []
        return 0
      }
      this.fileName5 = response.result
      this.$message({
        message: '操作成功',
        type: 'success',
        duration: 1500
      })
      this.getUrl()
    },
    handleSuccess6(response, file, fileList) {
      if (Number(fileList[0].response.code) < 0) {
        this.$alert(fileList[0].response.msg)
        this.fileList6 = []
        return 0
      }
      this.fileName6 = response.result
      this.$message({
        message: '操作成功',
        type: 'success',
        duration: 1500
      })
      this.getUrl()
    },
    handleSuccess7(response, file, fileList) {
      if (Number(fileList[0].response.code) < 0) {
        this.$alert(fileList[0].response.msg)
        this.fileList7 = []
        return 0
      }
      this.fileName7 = response.result
      this.$message({
        message: '操作成功',
        type: 'success',
        duration: 1500
      })
      this.getUrl()
    },
    handleSuccess8(response, file, fileList) {
      if (Number(fileList[0].response.code) < 0) {
        this.$alert(fileList[0].response.msg)
        this.fileList8 = []
        return 0
      }
      this.fileName8 = response.result
      this.$message({
        message: '操作成功',
        type: 'success',
        duration: 1500
      })
      this.getUrl()
    },
    beforeExcelUpload(file) {
      console.warn(file)
      const isJPG = (file.type === 'application/x-zip-compressed' || file.type === 'application/zip')
      if (!isJPG) {
        this.$alert('上传压缩包只能是 zip 格式!')
      }
      return isJPG
    },
    handleError(err, file, fileList) {
      console.log(err + file + fileList)
    }
  }
}
</script>
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
<style scope>
.import-excel-input-num {
  width: 100px;
  float: left;
  margin-right: 5px;
}
.import-excel-input {
  width: 245px;
  float: left;
}
.import-excel {
  height: 60px;
  position: relative;
}
.import-button {
  float: right;
  margin-right: 37px;
}
.import-excel .import-excel-input .el-input__inner {
  color: black;
}
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 23px 0;
}
.el-divider {
  background-color: #dcdfe6;
  position: relative;
}
.span-div {
  height: 25px;
}
.span-div-red {
  height: 25px;
  color: red;
}
.span-upload {
  margin: 10px;
  font-size: 16px;
}
.span-upload-import {
  float: left;
  margin: 8px;
}
.el-upload-list {
  position: absolute;
  top: -6px;
  left: 270px;
  width: 245px;
}
</style>
